module.exports = __webpack_public_path__ + "static/media/program-10.57abc66e.webp";